import * as socialRuleset from './social.ruleset';
import { socialSchema } from './social.schema';
import { socialActions } from './social.actions';
import { Inventory } from '../buruburu/inventory';
import { socialGetters } from './social.getters';
import { Tutorial } from '../buruburu/tutorial';
import { Minigame } from '../minigame';
import { Immutable, SB } from '@play-co/replicant';
import { socialModifiers } from './social.modifiers';
import { socialMessages } from './social.messages';
import { socialProperties } from './social.properties';
import { ReplicantModuleState } from '../utils';

export type Social = typeof Social;
// eslint-disable-next-line no-redeclare
export namespace Social {
  export const $DEPENDENCIES = {
    Inventory,
    Tutorial,
    Minigame,
  };

  export const ruleset = socialRuleset;
  export const schema = socialSchema;
  export const getters = socialGetters(Social, $DEPENDENCIES);
  export const properties = socialProperties;
  export const messages = socialMessages;
  export const modifiers = socialModifiers;
  export const actions = socialActions(Social, $DEPENDENCIES);

  export type MutableState = ReplicantModuleState<Social>;
  export type State = Immutable<MutableState>;
}
